'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/classic/solid';
import { useDropdown } from '@/app/_lib/hooks';

/**
 * FavoritesListSelect - Dropdown for selecting a favorites list
 *
 * Purpose-built for favorites list selection with:
 * - Optional heart icon on selected item
 * - Checkmark for current selection in dropdown
 * - "Edit" hover indicator when list is selected
 */
export default function FavoritesListSelect(t0) {
  const $ = _c(47);
  const {
    identifier: t1,
    label: t2,
    options: t3,
    selectedOption,
    onSelect,
    showHeartOnSelected: t4,
    className: t5
  } = t0;
  const identifier = t1 === undefined ? "favorites-list-select" : t1;
  const label = t2 === undefined ? "Select a list" : t2;
  let t6;
  if ($[0] !== t3) {
    t6 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const options = t6;
  const showHeartOnSelected = t4 === undefined ? true : t4;
  const className = t5 === undefined ? "" : t5;
  const t7 = selectedOption?.list_name || selectedOption?.label;
  let t8;
  if ($[2] !== identifier || $[3] !== onSelect || $[4] !== options || $[5] !== t7) {
    t8 = {
      items: options,
      onSelect,
      selectedValue: t7,
      getItemValue: _temp,
      identifier
    };
    $[2] = identifier;
    $[3] = onSelect;
    $[4] = options;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const {
    isOpen,
    focusedIndex,
    containerRef,
    getTriggerProps,
    getListProps,
    getItemProps
  } = useDropdown(t8);
  const hasSelection = !!selectedOption;
  const getDisplayName = _temp2;
  const t9 = `group relative min-h-[1.5rem] border-b border-gray-10 hover:border-primary ${className}`;
  const t10 = `${identifier}-label`;
  let t11;
  if ($[7] !== label || $[8] !== t10) {
    t11 = <div id={t10} className="sr-only">{label}</div>;
    $[7] = label;
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const t12 = `flex items-center justify-between w-full min-h-[2rem] py-1 transition-all duration-100 bg-transparent border-none text-left focus:outline-none relative ${isOpen ? "z-[1000] text-primary" : ""}`;
  const t13 = `${identifier}-label`;
  let t14;
  if ($[10] !== getTriggerProps) {
    t14 = getTriggerProps();
    $[10] = getTriggerProps;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const t15 = `group-hover:indent-1 transition-all duration-500 text-xs flex-1 ${isOpen ? "indent-1" : ""}`;
  let t16;
  if ($[12] !== hasSelection || $[13] !== label || $[14] !== selectedOption || $[15] !== showHeartOnSelected) {
    t16 = hasSelection ? <><span className="absolute -top-[.9rem] indent-0 text-4xs capitalize text-light">{label}</span><span className="inline-block text-light text-sm capitalize">{getDisplayName(selectedOption)}</span>{showHeartOnSelected && <FontAwesomeIcon icon={faHeart} className="inline text-xs text-rose-500 ml-1" />}</> : <span className="capitalize text-base">{label}</span>;
    $[12] = hasSelection;
    $[13] = label;
    $[14] = selectedOption;
    $[15] = showHeartOnSelected;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== t15 || $[18] !== t16) {
    t17 = <span className={t15}>{t16}</span>;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== hasSelection || $[21] !== isOpen) {
    t18 = hasSelection && <div className="absolute right-0 flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500"><span className="text-primary text-xs mr-1">Edit</span><FontAwesomeIcon icon={faChevronRight} size="2xs" className={`duration-500 transition-all text-primary ${isOpen ? "rotate-90" : ""}`} aria-hidden="true" /></div>;
    $[20] = hasSelection;
    $[21] = isOpen;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== hasSelection || $[24] !== isOpen) {
    t19 = !hasSelection && <FontAwesomeIcon icon={faChevronRight} size="2xs" className={`duration-500 transition-all ml-3 ${isOpen ? "rotate-90 text-primary" : "text-light-3 group-hover:text-main"}`} aria-hidden="true" />;
    $[23] = hasSelection;
    $[24] = isOpen;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t17 || $[30] !== t18 || $[31] !== t19) {
    t20 = <button type="button" className={t12} aria-labelledby={t13} {...t14}>{t17}{t18}{t19}</button>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== focusedIndex || $[34] !== getItemProps || $[35] !== getListProps || $[36] !== isOpen || $[37] !== options || $[38] !== selectedOption || $[39] !== showHeartOnSelected) {
    t21 = isOpen && <ul className="absolute top-full left-0 w-full bg-white drop-shadow-lg z-[1060] max-h-[400px] overflow-y-auto" {...getListProps()}>{options.map((option_0, index) => {
        const optionName = getDisplayName(option_0);
        const isSelected = selectedOption && getDisplayName(selectedOption) === optionName;
        return <li key={option_0.list_name || option_0.label || option_0.value || index} {...getItemProps(option_0, index)}><div className={`flex justify-between items-center w-full py-2 px-2 bg-white text-left text-sm capitalize hover:bg-gray-5 cursor-pointer ${focusedIndex === index ? "bg-gray-5" : ""} ${index < options.length - 1 ? "border-b border-gray-5" : ""}`}><div className="text-base text-dark capitalize">{optionName}{isSelected && showHeartOnSelected && <FontAwesomeIcon icon={faHeart} className="inline text-xs text-red ml-1" />}</div>{isSelected && <FontAwesomeIcon icon={faCheck} className="inline text-xs text-lime-600" />}</div></li>;
      })}</ul>;
    $[33] = focusedIndex;
    $[34] = getItemProps;
    $[35] = getListProps;
    $[36] = isOpen;
    $[37] = options;
    $[38] = selectedOption;
    $[39] = showHeartOnSelected;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== containerRef || $[42] !== t11 || $[43] !== t20 || $[44] !== t21 || $[45] !== t9) {
    t22 = <div ref={containerRef} className={t9}>{t11}{t20}{t21}</div>;
    $[41] = containerRef;
    $[42] = t11;
    $[43] = t20;
    $[44] = t21;
    $[45] = t9;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
}
function _temp2(option) {
  return option?.list_name || option?.label || "";
}
function _temp(item) {
  return item.list_name || item.label;
}